$(document).ready(function() {
    $('#sliderBannerAbout').slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 4000,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        prevArrow: $('.sectionBannerAbout .arrowLeft'),
        nextArrow: $('.sectionBannerAbout .arrowRight'),
        lazyLoad: 'ondemand',
    });
    $('.sectionBannerAbout .element img').click(function (e) {
        $('#modalAbout .banner img').attr('src',this.src);
        $('#modalAbout').modal('open');
    });
});
